import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col,
} from "reactstrap";
import { Route, BrowserRouter, NavLink, Switch } from "react-router-dom";
import createHistory from "history/createBrowserHistory";
class PendingAmountDetails extends React.Component {
  constructor(props) {
    super(props);
    console.log("checkpropspending", props);
    this.state = { modal: false };
    const history = createHistory();
    const unlisten = history.listen((location, action) => {
      if (this.state.modal) {
        this.setState({ modal: false });
      }
    });
  }
  toggle() {
    this.setState({
      modal: !this.state.modal,
    });
  }

  render() {
    const { trips } = this.props;
    const msg = this.props.msg;
    return (
      <div className="notification-outer-container">
        <BrowserRouter>
          <div className="position-fixed notification-container">
            <span>
              {"Pay"} {trips.pending_liabilities} {"pending settlements"}
            </span>
            <NavLink
              onClick={(e) => this.toggle()}
              to="/assigned/pendingdetails"
            >
              i
            </NavLink>
            <Switch>
              <Route path="/assigned/pendingdetails">
                <Modal
                  isOpen={this.state.modal}
                  backdrop={"static"}
                  keyboard={false}
                  fade={false}
                  toggle={(e) => this.toggle()}
                >
                  <ModalHeader className="justify-content-center py-2 alert-secondary">
                    Details
                  </ModalHeader>
                  <ModalBody>
                    <div className="pending-trip-details">
                      {trips.pending_liabilities}
                    </div>
                    {trips &&
                      trips.data &&
                      trips.data.map((tripdata, k) => (
                        <div key={k} className="pending-trip-details">
                          <Row>
                            <Col xs="6" className="text-medium">
                              Trip Id:{" "}
                            </Col>
                            <Col xs="6">{tripdata.job_id}</Col>
                          </Row>
                          <Row>
                            <Col xs="6" className="text-medium">
                              Delivered At:{" "}
                            </Col>
                            <Col xs="6">{tripdata.delivered_at}</Col>
                          </Row>

                          <Row>
                            <Col xs="6" className="text-medium">
                              {tripdata.transaction_type} {"Amount: "}
                            </Col>
                            <Col xs="6">{tripdata.amount_paid}</Col>
                          </Row>

                          {/* {tripdata.cash_amount != "₹0" ?
                        <Row><Col xs='6' className='text-medium'>Cash Amount: </Col>
                        <Col xs='6'>{tripdata.cash_amount}</Col></Row>
                        :''}
                        {tripdata.card_amount != "₹0" ?
                        <Row><Col xs='6' className='text-medium'>Card Amount: </Col>
                        <Col xs='6'>{tripdata.card_amount}</Col></Row>
                        :''}
                        {tripdata.paytm_amount != "₹0" ?
                        <Row><Col xs='6' className='text-medium'>Paytm Amount: </Col>
                        <Col xs='6'>{tripdata.paytm_amount}</Col></Row>
                        :''}
                        {tripdata.sodexo_amount != "₹0" ?
                        <Row><Col xs='6' className='text-medium'>Sodexo Amount: </Col>
                        <Col xs='6'>{tripdata.sodexo_amount}</Col></Row>
                        :''}
                        {tripdata.total_refusal != 0 ?
                        <Row><Col xs='6' className='text-medium'>Total Refusal: </Col>
                        <Col xs='6'>{tripdata.total_refusal}</Col></Row>
                        :''} */}
                        </div>
                      ))}
                  </ModalBody>
                  <ModalFooter className="p-0 border-0">
                    <span className="col-6 text-center">
                      <NavLink
                        className="btn m-0 py-2"
                        exact
                        to="/assigned"
                        onClick={(e) => this.toggle()}
                      >
                        OK
                      </NavLink>
                    </span>{" "}
                  </ModalFooter>
                </Modal>
              </Route>
            </Switch>
          </div>
        </BrowserRouter>
      </div>
    );
  }
}
export default PendingAmountDetails;



// WEBPACK FOOTER //
// ./src/components/Assigned/PendingAmountDetails.js